import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import EquipmentViewRow from 'components/ui/tailwind/equipment/EquipmentViewRow';

const HEADERS = [
  'Equipment ID',
  'Type',
  'Equipment Type',
  'Size',
  'Owner',
];

export default class EquipmentViewModal extends React.Component {
  static propTypes = {
    equipment: PropTypes.object,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  hide = () => this.props.onHide();

  render() {
    return (
      <Modal
        dialogClassName="modal-override"
        show={this.props.show}
        onHide={() => this.hide()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Equipment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            <div className="flex text-grey-darker">
              {HEADERS.map((header, i) => {
                return (
                  <div
                    key={getKey(header, i)}
                    className="w-1/4"
                  >
                    <strong>{header}</strong>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mb-2">
            <EquipmentViewRow
              equipment={this.props.equipment}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="float-right">
            <div>
              <a
                onClick={() => this.hide()}
                className="mr-1"
              >
                Close
              </a>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

function getKey(header, i) {
  return `${header}-${i}`;
}
